import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PcpService } from '@core/data/pcp.service';
import { ApplicationService } from '@core/data/application.service';
import { ApplicationProgressSharedService } from '@core/data/application-progress-shared.service';
import { UtilService } from '@core/data/util.service';

const SERVICES = [ApplicationService, PcpService, ApplicationProgressSharedService, UtilService];

@NgModule({
  declarations: [],
  providers: [...SERVICES],
  imports: [
    CommonModule,
  ],
})
export class DataModule {
}
